import { toaster } from '../components/ui/toaster';
import { Toast } from '@chakra-ui/react';
import React from 'react';

export { toaster };

export const toast = (options: {
  title: string;
  description?: string;
  status?: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
}) => {
  const status = options.status || 'info';
  
  // Map status to Toast status prop
  const toastStatus = status === 'success' ? 'success' : 
                      status === 'error' ? 'error' : 
                      status === 'warning' ? 'warning' : 'info';

  toaster.create({
    render: ({ onClose }: { onClose: () => void }) => {
      return (
        <Toast.Root status={toastStatus} onClose={onClose}>
          <Toast.Title>{options.title}</Toast.Title>
          {options.description && (
            <Toast.Description>{options.description}</Toast.Description>
          )}
          <Toast.CloseTrigger />
        </Toast.Root>
      );
    },
    duration: options.duration || 3000,
  });
};
